import { Star, Quotes } from "@phosphor-icons/react";
import MarkerStroke from "./MarkerStroke";
import useReveal from "./useReveal";
import "./home.css";
import "./HomeTestimonials.css";

/*
 * Social proof. REAL testimonials only — never invent quotes.
 * The first entry mirrors the Review in public/index.html JSON-LD; keep the
 * quote + author in sync there. Add more entries to this array as they come
 * in; the grid handles 1–3 items (featured layout for a single one).
 */

export const TESTIMONIALS = [
  {
    quote:
      'אפליקציה ותוכנה סופר נוחות, מעוצבות להפליא ומאפשרות לנהל את הלו"ז והמשימות בצורה הכי פרקטית שיש (ולא לפספס כלום!). הכל מגובה, מוגן ומסודר במקום אחד, והכי נוח? אפשר לגשת להכל מכל מכשיר, בכל זמן ומכל מקום.',
    author: "יובל סופר",
    role: "קלינאית תקשורת",
    rating: 5,
  },
];

function Stars({ count }) {
  return (
    <span className="htes-stars" aria-label={`${count} מתוך 5 כוכבים`}>
      {Array.from({ length: count }).map((_, i) => (
        <Star key={i} size={16} weight="fill" />
      ))}
    </span>
  );
}

function HomeTestimonials() {
  const ref = useReveal();
  const single = TESTIMONIALS.length === 1;

  return (
    <section
      id="testimonials"
      className="home-section home-section--gray htes"
      aria-labelledby="htes-title"
    >
      <div
        className="home-shape home-shape--blob htes-shape-blob"
        aria-hidden="true"
      />
      <div
        className="home-shape home-shape--ring htes-shape-ring"
        aria-hidden="true"
      />

      <div className="home-container">
        <div className="home-head home-head--center">
          <h2 id="htes-title" className="home-h2 home-h2--display">
            מטפלים שכבר{" "}
            <span className="home-mark">
              עברו אלינו
              <MarkerStroke />
            </span>
            ולא חוזרים לאקסל
          </h2>
        </div>

        <div
          className={`htes-grid${single ? " htes-grid--single" : ""} home-reveal`}
          ref={ref}
        >
          {TESTIMONIALS.map((t) => (
            <figure
              className="htes-card home-card home-bubble--lg"
              key={t.author}
            >
              <Quotes
                size={28}
                weight="fill"
                className="htes-quote-icon"
                aria-hidden="true"
              />
              <Stars count={t.rating} />
              <blockquote className="htes-quote">{t.quote}</blockquote>
              <figcaption className="htes-author">
                <span className="htes-avatar" aria-hidden="true">
                  {t.author.charAt(0)}
                </span>
                <span>
                  <span className="htes-author-name">{t.author}</span>
                  <span className="htes-author-role">{t.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeTestimonials;
